import { openSupportChat } from '@/lib/supportChat';

/**
 * Contacto de ventas para el plan Enterprise, que no se puede contratar solo.
 *
 * La via preferida es el chat: el comercial ve ahi el plan y los locales del
 * usuario sin tener que preguntarlos. Pero no todos los proveedores de chat
 * dejan abrir el panel por codigo, asi que hay un correo detras.
 *
 * El correo NO es decoracion: es lo que impide que el boton de Enterprise sea un
 * boton muerto el dia que el chat no se deje abrir. Enterprise esta en la tabla
 * de precios; sacarlo del embudo por un problema tecnico seria la peor salida.
 */
export const SALES_EMAIL = 'hola@mytapstar.com';

const SALES_SUBJECT = 'Plan Enterprise';

/** Abre el chat con ventas; si no se puede, el correo. */
export function contactSales() {
  return openSupportChat({
    mailto: `mailto:${SALES_EMAIL}?subject=${encodeURIComponent(SALES_SUBJECT)}`,
  });
}

/** El de soporte, el mismo que publican los datos de empresa (`EMPRESA` en `jsonLd.js`). */
export const SUPPORT_EMAIL = 'soporte@tapstar.es';

const SUPPORT_SUBJECT = 'Soporte MyTapstar';

/**
 * Contacto con soporte desde la app: «Soporte» en el menú del avatar y los
 * botones de soporte de gbusiness.
 *
 * Abre el chat, que en la app se monta sin burbuja (ver `Layout.jsx`). Si no se
 * puede —bloqueador de anuncios, red caída, o el script aún esperando la
 * identidad—, abre un correo a soporte: un botón de «hablar con soporte» que no
 * hace nada es peor que no tenerlo.
 */
export function contactSupport(subject = SUPPORT_SUBJECT) {
  return openSupportChat({
    mailto: `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`,
  });
}
